<template>
  <div style="position:relative" v-bind:class="{ open: openSuggestion }" class="auto-complete-device">
    <i class="dropdown icon" @click="triggerFocusEvent()"></i>
    <div v-bind:class="{ activeotherInput: certificateTypeNameClass }">
      <div style="display:none" v-bind:class="{ activeother: certificateTypeNameClass }">Other</div>

      <input
        class="form-control search-ul-text"
        type="text"
        :value="value"
        readonly
        @input="updateValue($event.target.value)"
        ref="inputTag"
        @keydown.enter="enter"
        @keydown.down="down"
        @keydown.up="up"
        @blur="blur($event.target.value)"
        @click="openDropdown"
        :placeholder="placeholder"
      />
    </div>
    <ul class="dropdown-menu search-ul" style="width:100%">
      <li
        v-for="(suggestion, index) in matches"
        :key="index"
        v-bind:class="{ disabled: suggestion == 'Other Device Class' }"
        @click="suggestionClick(index)"
      >
        <a @mousedown.prevent="down(suggestion)">{{ suggestion }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    certificateTypeNameClass: {
      type: Boolean,
      required: false,
    },
    value: {
      type: String,
      required: true,
    },
    suggestions: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      open: false,
      current: 0,
    };
  },
  computed: {
    // Filtering the suggestion based on the input
    matches() {
      return this.suggestions.filter(
        (obj) => (obj.toLowerCase().indexOf(this.value.toLowerCase()) >= 0).toString(),
      );
    },
    openSuggestion() {
      return (
        this.selection !== '' && this.matches.length !== 0 && this.open === true
      );
    },
  },
  methods: {
    triggerFocusEvent() {
      if (!this.open) {
        this.$refs.inputTag.click();
        this.$refs.inputTag.focus();
        this.open = true;
      } else this.open = false;
    },
    openDropdown() {
      this.open = true;
    },
    updateValue(value) {
      if (this.open === false) {
        this.open = true;
        this.current = 0;
      }
      this.$emit('input', value);
    },
    // When enter pressed on the input
    enter() {
      this.$emit('input', this.matches[this.current]);
      this.open = false;
    },
    // When up pressed while suggestions are open
    up() {
      if (this.current > 0) {
        this.current -= 1;
      }
    },
    // When up pressed while suggestions are open
    down() {
      if (this.current < this.matches.length - 1) {
        this.current += 1;
      }
    },
    blur(value) {
      setTimeout(() => {
        this.open = false;
      }, 200);
      // alert(value+'1')
      if (value !== 'Other Device Class') {
        this.$emit('input', value);
        this.$emit('OpenWith');
      }
      // this.open = false;
    },
    // When one of the suggestion is clicked
    suggestionClick(index) {
      // alert(this.matches[index] + '2')
      if (this.matches[index] !== 'Other Device Class') {
        this.$emit('input', this.matches[index]);
        this.$emit('OpenWith');
        this.certificateTypeNameClass = false;
        this.open = false;
      }
    },
  },
};
</script>
<style>
.form-control[readonly] {
  background-color: #fff !important;
}
.disabled {
  background: #c5c5c5;
  opacity: 0.9;
  color: #000;
}
.activeother {
  width: 50px;
  position: absolute;
  display: block !important;
  height: 32px;
  padding-top: 5px;
  background: #f0f0f0;
  color: #333;
  margin-top: 1px;
  margin-left: 2px;
  padding-left: 4px;
}
.activeotherInput input {
  padding-left: 60px;
}
.auto-complete-device ul{
  padding-top: 6px;
  overflow-x: scroll;
}
.auto-complete-device.open:after{
  content: '';
  display: flex;
  align-items: center;
  position: absolute;
  top: 32px;
  left: 12px;
  right: -13px;
  border: 0.5px solid #000000;
  opacity:0.5;
  width: 96%;
}
.auto-complete-device .search-ul .active a{
  border:1px solid #0A99ff !important;
  font-weight: 600 !important;
}
.auto-complete-device .search-ul .active a:hover{
  border:1px solid #0A99ff !important;
}
/* .auto-complete-device .dropdown-menu > li > a:focus, .dropdown-menu > li > a:hover{
  background-color: #e6e6e6 !important;
} */
.auto-complete-device .dropdown-menu>.active>a, .dropdown-menu>.active>a:focus, .dropdown-menu>.active>a:hover{
  border:1px solid #0A99ff !important;
}
.auto-complete-device .dropdown-menu li.active,
.auto-complete-device .dropdown-menu li:hover{
  border:1px solid #0A99ff !important;
}
.auto-complete-device .dropdown-menu li{
  padding: 5px 0px 5px 12px;
}
.auto-complete-device .dropdown-menu>li>a{
  padding: 0px !important;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300 !important;
  font-size: 18px !important;
  line-height: 25px !important;
  color: #333333 !important;
}
.open .search-ul{
  border-color: #000000 !important;
  max-height: 229px !important;
}
.auto-complete-device .form-control{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 18px !important;
  line-height: 25px !important;
  color: #333333;
  border: 0.5px solid #000000 !important;
}
.open .form-control.search-ul-text{
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom: none !important;
}
.auto-complete-device .dropdown.icon:before {
  content: "";
  float: right;
  right: 6px;
  position: absolute;
  top: 4px;
  border: 1px solid #000000;
  padding: 7px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  border-width: 0 1px 1px 0;
}
.open .dropdown.icon:before{
  transform: rotate(225deg) !important;
  top: 12px;
}
</style>
